import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Grid,
  Box,
  Button,
  Divider,
  LinearProgress,
  Breadcrumbs,
  Container,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Modal,
} from "@material-ui/core";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import PurchaseRequestFormComponent from "src/components/forms/PurchaseRequestFormComponent";

import {
  getPurchaseRequestById,
  updatePurchaseRequest,
  getYearList,
  getPurchaseDetails,
  getAllFiles,
  deleteFiles,
  contractPurchaseUpdate,
} from "src/redux/actions/purchaseRequest.action";

import { fetchUnit, fetchCurrencies } from "src/redux/actions/reference.action";

import { getBrands } from "src/redux/actions/brand.action";
import { withRouter, useParams, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Alert, AlertTitle } from "@material-ui/lab";

import moment from "moment";
import { green, red, yellow } from "@material-ui/core/colors";
import Swal from "sweetalert2";
import AssignFormModal from "src/components/modals/AssignFormModal";
import ApprovalModal from "src/components/modals/ApprovalModal";
import Page from "src/components/Page";
import FilesUploadComponent from "src/components/FilesUploadComponent";
import MaterialTable from "material-table";
import Moment from "moment";
import Axios from "axios";
import { imageUrl } from "src/Constants";
import download from "js-file-download";
import { Backdrop } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import ContractCreateForm from "src/components/forms/ContractCreateForm";
import { httpClient } from "src/utils/HttpClient";
import { hasRoleDOA } from "src/utils/Auth";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    "& .MuiChip-root": {
      margin: theme.spacing(0.5),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const NewPurchaseRequest = ({ history }) => {
  const classes = useStyles();

  const params = useParams();

  const dispatch = useDispatch();
  const [openAttModal, setOpenAttModal] = useState(false);
  const {
    result: {
      countryid,
      currencyid,
      companyid,
      secureid,
      perid,
      country_code,
      fullname,
      email,
    },
  } = useSelector((state) => state.loginReducer);

  const { purchaseRequest, purchaseRequestDetails, attachFiles, prSuppliers } =
    useSelector((state) => state.purchaseRequestReducer);

  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  const [openModalAssign, setOpenModalAssign] = useState(false);
  const [PRStatus, setPRStatus] = useState(5);

  const [refCountries, setRefCountries] = useState({
    REF_EX_RATE: null,
    REF_COUNTRY_NAME: "",
    REF_COUNTRYID: null,
  });

  const [POSTBY, setPOSTBY] = useState(null);

  const [year, setYear] = useState(null);
  const [assignees, setAssignees] = useState({
    ASSIGN_PURCHASE_NAME: "",
    ASSIGN_PURCHASE_ID: "",
    ASSIGN_PURCHASE_EMAIL: "",
  });

  useEffect(() => {
    dispatch(getPurchaseRequestById(params.id));
    dispatch(getPurchaseDetails(params.id));
    dispatch(getAllFiles(params.id));
    if (purchaseRequest.data) {
      dispatch(getYearList());
      const { PR_YEAR } = purchaseRequest.data;
      setYear(PR_YEAR);
      dispatch(fetchUnit());
      dispatch(fetchCurrencies(currencyid));
      dispatch(getBrands(countryid, companyid, secureid));
    }

    return () => {};
  }, [currencyid, dispatch, params.id]);

  let submitPurchaseRequestForm = null;

  const handleSubmitMyForm = (e, status) => {
    if (submitPurchaseRequestForm) {
      submitPurchaseRequestForm(e, status);
    }
  };

  const bindSubmitForm = (submitForm) => {
    submitPurchaseRequestForm = submitForm;
  };

  const handleSubmitForm = (values) => {
    let data = {};

    if (PRStatus) {
      data = {
        ...values,
        PR_STATUS: PRStatus,
      };
    } else {
      data = values;
    }

    const { PRHIDX } = values;
    delete data.PRHIDX;
    delete data.CREATED_DATE;
    delete data.UPDATED_AT;

    if (PRStatus === 50) {
      data.ASSIGN_PURCHASE_NAME = assignees.ASSIGN_PURCHASE_NAME;
      data.ASSIGN_PURCHASE_ID = assignees.ASSIGN_PURCHASE_ID;
      data.ASSIGN_PURCHASE_EMAIL = assignees.ASSIGN_PURCHASE_EMAIL;
      data.ASSIGN_DATE = moment().format("YYYY-MM-DD HH:mm:ss");
    }

    if (data.PR_TYPE !== 2) {
      data.REF_PR_NO = null;
    }

    dispatch(updatePurchaseRequest(PRHIDX, data, history));
  };

  const renderForm = () => {
    return (
      <div>
        {purchaseRequest.isLoading && <LinearProgress color="secondary" />}
        <ContractCreateForm
          bindSubmitForm={bindSubmitForm}
          initialValues={purchaseRequest.data}
          handleSubmitForm={handleSubmitForm}
          suppliers={prSuppliers}
        />
      </div>
    );
  };

  if (purchaseRequest.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert — <strong>Get Purchase request detail!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page
      className={classes.root}
      title={`Purchase Requisition Form : ${
        purchaseRequest.data && purchaseRequest.data.PR_NO
          ? purchaseRequest.data.PR_NO
          : "New PR"
      }`}
    >
      <Container maxWidth={false}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={() => {
              history.goBack();
            }}
          >
            Search Contract
          </Link>
          <Link color="textPrimary" aria-current="page">
            Create Contract
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader subheader="" title="Create Contract" />
          <Divider />
          <CardContent>
            {renderForm()}
            <Box m={1} display="flex" flexDirection="row" border={1}>
              <Box>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setOpenAttModal(true);
                  }}
                >
                  <AttachFileIcon />
                  ATTACH FILE
                </Button>
              </Box>
              <Box p={1} display="flex" flexWrap="flexWrap">
                {attachFiles.data &&
                  attachFiles.data.map((i) => (
                    <Chip
                      label={i.ATT_FILENAME}
                      onDelete={() => {
                        dispatch(deleteFiles(i.ATTIDX, params.id));
                      }}
                      className={classes.chip}
                    />
                  ))}
              </Box>
            </Box>
            <Divider />
            <Grid item xs={12} sm={12}>
              <Box display="flex" justifyContent="flex-end">
                {hasRoleDOA(authorizePR.data, ["Legal"]) &&
                  purchaseRequest.data && (
                    <>
                      {purchaseRequest.data.PR_STATUS === 52 && (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              Swal.fire({
                                title: "Confirm to Required Contract ?",
                                text: "You won't be able to Required Contract this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  var data = {
                                    CONTRACT_LEGAL_RC_NAME: fullname,
                                    CONTRACT_LEGAL_RC_EMAIL: email,
                                    CONTRACT_LEGAL_RC_ID: perid,
                                    CONTRACT_LEGAL_RC_DATE: Moment(),
                                    PR_STATUS: 49,
                                  };
                                  dispatch(
                                    contractPurchaseUpdate(
                                      params.id,
                                      data,
                                      history
                                    )
                                  );
                                }
                              });
                            }}
                          >
                            Contract is required
                          </Button>
                          <Button
                            variant="contained"
                            color="danger"
                            onClick={() => {
                              Swal.fire({
                                title: "Confirm to Not Required Contract ?",
                                text: "You won't be able to Not Required Contract this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  var data = {
                                    CONTRACT_LEGAL_RC_NAME: fullname,
                                    CONTRACT_LEGAL_RC_EMAIL: email,
                                    CONTRACT_LEGAL_RC_ID: perid,
                                    CONTRACT_LEGAL_RC_DATE: Moment(),
                                    PR_STATUS: 53,
                                  };
                                  dispatch(
                                    contractPurchaseUpdate(
                                      params.id,
                                      data,
                                      history
                                    )
                                  );
                                }
                              });
                            }}
                          >
                            Contract is not required
                          </Button>
                        </>
                      )}
                      {purchaseRequest.data &&
                        purchaseRequest.data.PR_STATUS === 49 && (
                          <Button
                            variant="contained"
                            color="default"
                            onClick={() => {
                              Swal.fire({
                                title: "Confirm to recieve ?",
                                text: "You won't be able to receive this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  var data = {
                                    CONTRACT_LEGAL_R_NAME: fullname,
                                    CONTRACT_LEGAL_R_EMAIL: email,
                                    CONTRACT_LEGAL_R_ID: perid,
                                    CONTRACT_LEGAL_RECEIVED_DATE: Moment(),
                                    PR_STATUS: 54,
                                  };
                                  dispatch(
                                    contractPurchaseUpdate(
                                      params.id,
                                      data,
                                      history
                                    )
                                  );
                                }
                              });
                            }}
                          >
                            Received Job
                          </Button>
                        )}
                      {purchaseRequest.data &&
                        purchaseRequest.data.PR_STATUS === 54 && (
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: green[400],
                            }}
                            onClick={() => {
                              Swal.fire({
                                title:
                                  "Confirm to Final draft is done and Ready to sign off ?",
                                text: "You won't be able to Final draft is done and Ready to sign off this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  var data = {
                                    CONTRACT_LEGAL_F_NAME: fullname,
                                    CONTRACT_LEGAL_F_EMAIL: email,
                                    CONTRACT_LEGAL_F_ID: perid,
                                    CONTRACT_LEGAL_F_DATE: Moment(),
                                    PR_STATUS: 55,
                                  };
                                  dispatch(
                                    contractPurchaseUpdate(
                                      params.id,
                                      data,
                                      history
                                    )
                                  );
                                }
                              });
                            }}
                          >
                            Final draft is done and Ready to sign off
                          </Button>
                        )}
                      {(purchaseRequest.data.PR_STATUS === 54 ||
                        purchaseRequest.data.PR_STATUS === 56) && (
                        <>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: yellow[600],
                            }}
                            onClick={() => {
                              Swal.fire({
                                title: "Submit your remark for hold",
                                input: "textarea",
                                inputAttributes: {
                                  autocapitalize: "off",
                                },
                                showCancelButton: true,
                                confirmButtonText: "Hold",
                                showLoaderOnConfirm: true,
                                inputValidator: (value) => {
                                  return new Promise((resolve) => {
                                    if (value) {
                                      resolve();
                                    } else {
                                      resolve(
                                        "Please fill to remark for hold !"
                                      );
                                    }
                                  });
                                },
                                preConfirm: (remark) => {
                                  return httpClient
                                    .put(
                                      `/purchase-request/contract-update/${params.id}`,
                                      {
                                        PR_H_REMARKs: {
                                          REMARK_TEXT: remark,
                                          PR_STATUS: 59,
                                        },
                                        PR_STATUS: 59,
                                        CONTRACT_LEGAL_R_NAME: fullname,
                                        CONTRACT_LEGAL_R_EMAIL: email,
                                        CONTRACT_LEGAL_R_ID: perid,
                                        CONTRACT_LEGAL_RECEIVED_DATE: Moment(),
                                      }
                                    )
                                    .then((result) => {
                                      return result.data;
                                    })
                                    .catch((error) => {
                                      Swal.showValidationMessage(
                                        `Request failed: ${error}`
                                      );
                                    });
                                },
                                allowOutsideClick: () => !Swal.isLoading(),
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  Swal.fire({
                                    text: `The Purchase Requesition (${
                                      purchaseRequest.data &&
                                      purchaseRequest.data.PR_NO
                                    }) has hold`,
                                    icon: "success",
                                  }).then(() => {
                                    history.goBack();
                                  });
                                }
                              });
                            }}
                          >
                            Hold
                          </Button>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: yellow[600],
                            }}
                            onClick={() => {
                              Swal.fire({
                                title: "Confirm to approve ?",
                                text: "You won't be able to approve this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  var data = {
                                    CONTRACT_LEGAL_C_NAME: fullname,
                                    CONTRACT_LEGAL_C_EMAIL: email,
                                    CONTRACT_LEGAL_C_ID: perid,
                                    CONTRACT_LEGAL_COMPLETED_DATE: Moment(),
                                    PR_STATUS: 57,
                                  };
                                  dispatch(
                                    contractPurchaseUpdate(
                                      params.id,
                                      data,
                                      history
                                    )
                                  );
                                }
                              });
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: red[500],
                            }}
                            onClick={() => {
                              Swal.fire({
                                title: "Submit your remark for reject",
                                input: "textarea",
                                inputAttributes: {
                                  autocapitalize: "off",
                                },
                                showCancelButton: true,
                                confirmButtonText: "Rejected",
                                showLoaderOnConfirm: true,
                                inputValidator: (value) => {
                                  return new Promise((resolve) => {
                                    if (value) {
                                      resolve();
                                    } else {
                                      resolve(
                                        "Please fill to remark for reject !"
                                      );
                                    }
                                  });
                                },
                                preConfirm: (remark) => {
                                  return httpClient
                                    .put(
                                      `/purchase-request/contract-update/${params.id}`,
                                      {
                                        PR_H_REMARKs: {
                                          REMARK_TEXT: remark,
                                          PR_STATUS: 58,
                                        },
                                        PR_STATUS: 58,
                                        CONTRACT_LEGAL_REJECTED_ID: perid,
                                        CONTRACT_LEGAL_REJECTED_DATE: Moment(),
                                        CONTRACT_LEGAL_REJECTED_NAME: fullname,
                                        CONTRACT_LEGAL_REJECTED_EMAIL: email,
                                      }
                                    )
                                    .then((result) => {
                                      return result.data;
                                    })
                                    .catch((error) => {
                                      Swal.showValidationMessage(
                                        `Request failed: ${error}`
                                      );
                                    });
                                },
                                allowOutsideClick: () => !Swal.isLoading(),
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  Swal.fire({
                                    text: `The Purchase Requesition (${
                                      purchaseRequest.data &&
                                      purchaseRequest.data.PR_NO
                                    }) has rejected`,
                                    icon: "success",
                                  }).then(() => {
                                    history.goBack();
                                  });
                                }
                              });
                            }}
                          >
                            Rejected
                          </Button>
                        </>
                      )}
                    </>
                  )}
                {hasRoleDOA(authorizePR.data, ["Requestor", "Legal"]) &&
                  purchaseRequest.data &&
                  purchaseRequest.data.PR_STATUS === 55 && (
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: green[400],
                      }}
                      onClick={() => {
                        Swal.fire({
                          title: "Confirm to submit ?",
                          text: "You won't be able to submit this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            var data = {
                              CONTRACT_LEGAL_SUB_NAME: fullname,
                              CONTRACT_LEGAL_SUB_EMAIL: email,
                              CONTRACT_LEGAL_SUB_ID: perid,
                              CONTRACT_LEGAL_SUBMITTED_DATE: Moment(),
                              PR_STATUS: 56,
                            };
                            dispatch(
                              contractPurchaseUpdate(params.id, data, history)
                            );
                          }
                        });
                      }}
                    >
                      Submit
                    </Button>
                  )}
                <Button
                  onClick={() => {
                    history.goBack();
                  }}
                  variant="contained"
                >
                  BACK
                </Button>
              </Box>
            </Grid>
            <AssignFormModal
              openModal={openModalAssign}
              handleCloseModal={() => {
                setOpenModalAssign(false);
              }}
              handleSubmit={(value) => {
                setAssignees({
                  ASSIGN_PURCHASE_NAME: `${value.PER_FIRSTNAME} ${value.PER_SURNAME}`,
                  ASSIGN_PURCHASE_ID: value.PER_ID,
                  ASSIGN_PURCHASE_EMAIL: value.PER_EMAIL,
                });
                setPRStatus(50);
                handleSubmitMyForm(window.event);
              }}
            />
          </CardContent>
        </Card>
      </Container>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={openAttModal}
        onClose={() => {
          setOpenAttModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openAttModal}>
          <div className={classes.paper}>
            {/* {ctrlAttachfile() && (
              <FilesUploadComponent
                headerId={params.id}
                handleUpload={() => {
                  dispatch(getAllFiles(params.id));
                }}
              />
            )} */}
            <FilesUploadComponent
              headerId={params.id}
              handleUpload={() => {
                dispatch(getAllFiles(params.id));
              }}
            />
            <MaterialTable
              columns={[
                {
                  title: "File Name",
                  field: "ATT_FILENAME",
                  render: (rowData) => {
                    return (
                      <>
                        <FileCopyIcon />
                        {rowData.ATT_FILENAME}
                      </>
                    );
                  },
                },
                {
                  title: "Date Uploaded",
                  field: "CREATED_DATE",
                  type: "date",
                  render: (rowData) =>
                    Moment(rowData.CREATED_DATE).format("DD-MMM-YY"),
                },
                {
                  title: "Download",
                  field: "ATTIDX",
                  render: (rowData) => (
                    <CloudDownloadIcon
                      onClick={() => {
                        Axios({
                          url: `${imageUrl}/upload/purchase-files/${rowData.ATT_FILENAME}`,
                          method: "GET",
                          responseType: "blob",
                        })
                          .then((res) => {
                            download(res.data, rowData.ATT_FILENAME);
                          })
                          .catch((err) => {
                            Swal.fire(
                              "The system has error.",
                              err.message,
                              "error"
                            );
                          });
                      }}
                    />
                  ),
                },
              ]}
              data={attachFiles.data}
              editable={{
                // isDeletable: () => {
                //   return ctrlAttachfile();
                // },
                onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    setTimeout(() => {
                      dispatch(deleteFiles(oldData.ATTIDX, params.id));
                      resolve();
                    }, 1000);
                  }),
              }}
              options={{
                showTitle: false,
                search: false,
                padding: false,
              }}
            />
            <br />
            <Divider />
            <br />
            <Button
              variant="contained"
              onClick={() => {
                setOpenAttModal(false);
              }}
            >
              Close
            </Button>
          </div>
        </Fade>
      </Modal>
    </Page>
  );
};

export default withRouter(NewPurchaseRequest);
